import { render, staticRenderFns } from "./Airtime.vue?vue&type=template&id=ff3a4992&scoped=true&"
import script from "./Airtime.vue?vue&type=script&lang=js&"
export * from "./Airtime.vue?vue&type=script&lang=js&"
import style0 from "./Airtime.vue?vue&type=style&index=0&id=ff3a4992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3a4992",
  null
  
)

export default component.exports